<template>
  <v-container>
    <v-layout text-xs-center wrap>
      <v-flex xs12>Aide</v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data: () => ({}),
  methods: {},
  mounted() {}
};
</script>
